import type { ExtractPropTypes, PropType } from 'vue'

export const fileUploadProps = {
  value: {
    type: Array as PropType<ApiFile.Item[]>,
    default: () => []
  },
  isSimple: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  filesCol: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({ span: 12, xl: 8, xxl: 6 })
  },
  viewRaw: {
    type: Boolean as PropType<boolean>,
    default: false
  }
}

export type FileUploadProps = ExtractPropTypes<typeof fileUploadProps>
